import { ECHOES, ECHO_LIST, type Echo } from '@/data/echoes'
import { HUNTS, type HuntType } from '@/data/hunts'
import type { Rarity } from '@/data/constants'

export interface HuntResult {
  success: boolean
  echo?: Echo
  isGlimmering?: boolean
}

const GLIMMERING_CHANCE = 0.01

export function rollEcho(huntType: HuntType, placeId: string): HuntResult {
  const hunt = HUNTS[huntType]

  // Check if hunt succeeds
  if (Math.random() > hunt.successRate) {
    return { success: false }
  }

  // Get available echoes at this place
  const available = ECHO_LIST.filter((echo) => echo.places.includes(placeId))

  if (available.length === 0) {
    return { success: false }
  }

  // Roll for rarity
  const roll = Math.random() * 100
  let rarity: Rarity = 'common'
  let cumulative = 0

  for (const [r, weight] of Object.entries(hunt.weights) as [Rarity, number][]) {
    cumulative += weight
    if (roll < cumulative) {
      rarity = r
      break
    }
  }

  // Get candidates of that rarity
  let candidates = available.filter((echo) => echo.rarity === rarity)

  // Fallback to any available if no candidates of that rarity
  if (candidates.length === 0) {
    candidates = available
  }

  // Pick random echo
  const picked = candidates[Math.floor(Math.random() * candidates.length)]

  if (!picked) {
    return { success: false }
  }

  return {
    success: true,
    echo: picked,
    isGlimmering: Math.random() < GLIMMERING_CHANCE,
  }
}

export function getEchoById(id: string): Echo | undefined {
  return ECHOES[id]
}
